import React from 'react';
import moment from 'moment';
import { TableColumn } from '../../types/Table';
import { Translated } from '../../components/UI/Core';
import { ParkingTransaction, ParkingUsage } from '../../models/Parking';

export const parkingUsageTableColumns = (): Array<TableColumn<ParkingUsage>> => [
  {
    Header: <Translated id="parking.Id" />,
    id: 'Id',
    accessor: 'Id',
    isVisible: false,
    disableSortBy: true,
    disableFilters: true,
  },
  {
    Header: <Translated id="parking.Name" />,
    id: 'Name',
    accessor: 'Name',
  },
  {
    Header: <Translated id="parking.IsOccupied" />,
    id: 'IsOccupied',
    accessor: 'IsOccupied',
    disableFilters: true,
    Cell: ({ value }: { value: boolean }) => <span>{value ? 'Yes' : 'No'}</span>,
  },
  {
    Header: <Translated id="parking.LastTransactionDateTime" />,
    id: 'LastTransactionDateTime',
    accessor: 'LastTransactionDateTime',
    disableFilters: true,
    Cell: ({ value }: { value: string }) => <span>{moment(value).format('DD MMM YYYY HH:mm')}</span>,
  },
];

export const parkingTransactionTableColumns = (): Array<TableColumn<ParkingTransaction>> => [
  {
    Header: <Translated id="parking.Id" />,
    id: 'Id',
    accessor: 'Id',
    isVisible: false,
    disableSortBy: true,
    disableFilters: true,
  },
  {
    Header: <Translated id="parking.Name" />,
    id: 'Name',
    accessor: 'Name',
  },
  {
    Header: <Translated id="parking.IsOccupied" />,
    id: 'IsOccupied',
    accessor: 'IsOccupied',
    disableFilters: true,
    Cell: ({ value }: { value: boolean }) => <span>{value ? 'Yes' : 'No'}</span>,
  },
  {
    Header: <Translated id="parking.TransactionDateTime" />,
    id: 'TransactionDateTime',
    accessor: 'TransactionDateTime',
    disableFilters: true,
    Cell: ({ value }: { value: string }) => <span>{moment(value).format('DD MMM YYYY HH:mm')}</span>,
  },
];
